import React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AssignmentIcon from '@mui/icons-material/Assignment';

const stepsData = [
  {
    icon: <InfoIcon />,
    title: 'Order Info',
  },
  {
    icon: <AssignmentIcon />,
    title: 'Order Details',
  },
  {
    icon: <LocalShippingIcon />,
    title: 'Shipping',
  },
  {
    icon: <LocalShippingIcon />,
    title: 'Order Summary',
  },
];

const stepperData = [
  'Order Info',
  'Order Details',
  'Shipping',
  'Order Summary',
];

export { stepsData, stepperData };
